import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { getOs } from '@/utils/RandomUtils.ts';
import type { Hotkey } from '@/types/Hotkey.ts';
import { acceleratorToLabel } from '@/utils/HotkeyUtils.ts';

export const getHotkeyLabel = (hotkey: Hotkey) => {
    const settingsStore = useSettingsStore();

    if (!(hotkey in settingsStore.hotkeys)) {
        return hotkey;
    }

    let output: string;
    if (getOs() === 'windows') {
        output = settingsStore.hotkeys[hotkey]
            .replace('CmdOrCtrl', 'ctrl')
            .replace('CommandOrControl', 'ctrl');
    } else {
        output = settingsStore.hotkeys[hotkey]
            .replace('CmdOrCtrl', 'cmd')
            .replace('CommandOrControl', 'cmd');
    }

    return acceleratorToLabel(output);
};

export const getIndicatorMinWidth = () => {
    return {
        'min-w-11': getOs() === 'windows',
        'min-w-9': getOs() !== 'windows',
    };
};
